import React from 'react';
import { Switch, HashRouter, Route } from 'react-router-dom';
import { StandardRoutes } from '@sdir/auth/lib/components';
import CertificatePage from './Pages/CertificatePage/CertificatePage';
import SearchEndorsementPage from './Pages/SearchEndorsementPage/SearchEndorsementPage';
import EndorsementPage from './Pages/EndorsementPage/EndorsementPage';
import SearchSidPage from './Pages/SearchSidPage/SearchSidPage';
import SidPage from './Pages/SidPage/SidPage';
import SearchForm from './Organisms';
import { DEFAULT_LANG } from '../helpers/languageHelpers';
import { routes } from '../constants/routes';
import HealthPage from './Pages/HealthPage/HealthPage';
import SearchHealthPage from './Pages/SearchHealthPage/SearchHealthPage';
import DispensationPage from './Pages/DispensationPage/DispensationPage';
import SearchDispensationPage from './Pages/SearchDispensationPage/SearchDispensationPage';
import HomePage from './Pages/HomePage/HomePage';

type Props = {
  currentLanguage: string;
};

const Routes: React.FC<Props> = ({ currentLanguage = DEFAULT_LANG }) => {
  const languagePrepend = currentLanguage === DEFAULT_LANG ? '' : `/${currentLanguage}`;
  return (
    <HashRouter>
      <Switch>
        <Route exact path={`${languagePrepend}${routes.home}`} component={HomePage} />
        <Route
          exact
          path={`${languagePrepend}${routes.certificateSearch}`}
          component={SearchForm}
        />
        <Route
          exact
          path={`${languagePrepend}${routes.certificateByUid}`}
          component={CertificatePage}
        />
        <Route
          exact
          path={`${languagePrepend}${routes.endorsementSearch}`}
          component={SearchEndorsementPage}
        />
        <Route
          exact
          path={`${languagePrepend}${routes.endorsementByUid}`}
          component={EndorsementPage}
        />
        <Route
          exact
          path={`${languagePrepend}${routes.dispensationSearch}`}
          component={SearchDispensationPage}
        />
        <Route
          exact
          path={`${languagePrepend}${routes.dispensationByUid}`}
          component={DispensationPage}
        />
        <Route exact path={`${languagePrepend}${routes.sidSearch}`} component={SearchSidPage} />
        <Route exact path={`${languagePrepend}${routes.sidByUid}`} component={SidPage} />
        <Route
          exact
          path={`${languagePrepend}${routes.healthSearch}`}
          component={SearchHealthPage}
        />
        <Route exact path={`${languagePrepend}${routes.healthByUid}`} component={HealthPage} />
        <StandardRoutes />
      </Switch>
    </HashRouter>
  );
};

export default Routes;
